<script>
    import BaseDialog from './BaseDialog.svelte';

    let {
        dialogRef = $bindable(),
        downloadTranscriptFilename = $bindable(),
        downloadTranscriptIncludeHeaders = $bindable(),
        downloadTranscriptIncludeSpeaker = $bindable(),
        downloadTranscriptIncludeSection = $bindable(),
        downloadTranscriptUrl,
        downloadTranscriptLink = $bindable(),
        downloadTranscriptJson,
        downloadTranscriptText,
        onCreate,
        btn = ""
    } = $props();
</script>

<BaseDialog bind:dialogRef={dialogRef} size="sm:max-w-4xl" title="Download Transcript">
    {#snippet children({ dialog })}
        <div class="overflow-auto p-6">
            <div class="space-y-6">
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        Filename <span class="text-gray-500 text-xs">(.tsv will be appended)</span>
                    </label>
                    <input
                        class="focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-lg border-gray-300 shadow-sm px-4 py-2"
                        type="text"
                        bind:value={downloadTranscriptFilename}
                        placeholder="transcript"
                    />
                </div>

                <div class="border-t border-gray-200 pt-4">
                    <label class="block text-sm font-medium text-gray-700 mb-3">Export Options</label>
                    <div class="space-y-3">
                        <label class="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition">
                            <input
                                class="focus:ring-2 focus:ring-indigo-500 h-5 w-5 text-indigo-600 border-gray-300 rounded"
                                type="checkbox"
                                bind:checked={downloadTranscriptIncludeHeaders}
                            />
                            <div class="flex-1">
                                <span class="text-gray-900 font-medium">Include Headers</span>
                                <p class="text-sm text-gray-500">Add column headers to the file</p>
                            </div>
                        </label>

                        <label class="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition">
                            <input
                                class="focus:ring-2 focus:ring-indigo-500 h-5 w-5 text-indigo-600 border-gray-300 rounded"
                                type="checkbox"
                                bind:checked={downloadTranscriptIncludeSpeaker}
                            />
                            <div class="flex-1">
                                <span class="text-gray-900 font-medium">Include Speaker</span>
                                <p class="text-sm text-gray-500">Add speaker information column</p>
                            </div>
                        </label>

                        <label class="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition">
                            <input
                                class="focus:ring-2 focus:ring-indigo-500 h-5 w-5 text-indigo-600 border-gray-300 rounded"
                                type="checkbox"
                                bind:checked={downloadTranscriptIncludeSection}
                            />
                            <div class="flex-1">
                                <span class="text-gray-900 font-medium">Include Section</span>
                                <p class="text-sm text-gray-500">Add section information column</p>
                            </div>
                        </label>
                    </div>
                </div>

                <div class="flex items-center gap-3 pt-2">
                    <button class="{btn} py-2 px-6" onclick={onCreate}>Create Preview</button>
                    {#if downloadTranscriptUrl}
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a class="text-blue-600 hover:text-blue-800 font-medium underline" bind:this={downloadTranscriptLink} download={downloadTranscriptFilename}>
                            ⬇ Download File
                        </a>
                    {/if}
                </div>

                {#if downloadTranscriptJson || downloadTranscriptText}
                    <div class="border-t border-gray-200 pt-4">
                        <h4 class="text-sm font-medium text-gray-700 mb-2">Preview</h4>
                        <div class="bg-gray-50 rounded-lg p-4 max-h-64 overflow-auto">
                            {#if downloadTranscriptJson}
                                <pre class="text-xs text-gray-800 font-mono">{#each downloadTranscriptJson as x}{JSON.stringify(x) + "\n"}{/each}</pre>
                            {:else if downloadTranscriptText}
                                <pre class="text-xs text-gray-800 font-mono">{downloadTranscriptText}</pre>
                            {/if}
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    {/snippet}
</BaseDialog>
